import { useAuth } from '@/hooks/useAuth';
import { Link } from 'react-router-dom';
import { getTrialDaysRemaining, TRIAL_DURATION_DAYS } from '@/hooks/planAccess';

const PLAN_LABELS: Record<string, string> = {
  trial: 'Teste Grátis',
  starter: 'Starter',
  professional: 'Professional',
  business: 'Business',
  enterprise: 'Enterprise',
};

const PLAN_BADGES: Record<string, string> = {
  trial: 'bg-secondary-100 text-secondary-700 border-secondary-200',
  starter: 'bg-accent-100 text-accent-700 border-accent-200',
  professional: 'bg-primary-100 text-primary-700 border-primary-200',
  business: 'bg-amber-100 text-amber-700 border-amber-200',
  enterprise: 'bg-emerald-100 text-emerald-700 border-emerald-200',
};

export default function CurrentPlanBadge() {
  const { profile } = useAuth();
  const plan = profile?.plan || 'trial';
  const planLabel = PLAN_LABELS[plan] || plan;
  const badgeClass = PLAN_BADGES[plan] || 'bg-background-100 text-foreground-600 border-background-200';
  const isTrial = plan === 'trial';

  // Calculate trial expiration date
  let trialExpiryText = '';
  if (isTrial && profile?.created_at) {
    const createdAt = new Date(profile.created_at);
    const trialEnd = new Date(createdAt.getTime() + TRIAL_DURATION_DAYS * 24 * 60 * 60 * 1000);
    const daysRemaining = getTrialDaysRemaining(plan, profile.created_at);
    trialExpiryText = `Expira em ${trialEnd.toLocaleDateString('pt-BR')} (${daysRemaining !== null && daysRemaining > 0 ? `${daysRemaining} dias restantes` : 'hoje'})`;
  }

  return (
    <div className="bg-white dark:bg-background-100 rounded-2xl border border-background-200 dark:border-background-300 p-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-3 flex-1">
          <div className="w-10 h-10 rounded-xl bg-primary-50 dark:bg-primary-500/10 flex items-center justify-center flex-shrink-0">
            <i className="ri-vip-crown-line text-xl text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground-900 dark:text-foreground-100">
              Plano atual:{' '}
              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${badgeClass}`}>
                {planLabel}
              </span>
            </p>
            <p className="text-xs text-foreground-500 mt-0.5">
              {isTrial
                ? trialExpiryText || 'Teste grátis de 7 dias com até 500 mensagens'
                : `Limite mensal: ${(profile?.monthly_message_limit || 0).toLocaleString('pt-BR')} mensagens`}
            </p>
          </div>
        </div>
        <Link
          to="/subscription"
          className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-xl transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
        >
          <i className="ri-arrow-up-circle-line" />
          {isTrial ? 'Fazer Upgrade' : 'Gerenciar Plano'}
        </Link>
      </div>
    </div>
  );
}